import { useCore } from '$api-clients/hooks';

export function useGetClientGroup(clientGroupId: string | null, skip = false) {
  const shouldSkip = skip || !clientGroupId;

  // Fetch client group data
  const { data, error, isLoading, mutate } = useCore(
    '/client-groups/{clientGroupId}',
    shouldSkip
      ? null
      : {
          params: {
            path: {
              clientGroupId,
            },
          },
        },
  );

  return {
    clientGroup: data,
    error,
    isLoading,
    mutate,
  };
}
